import React from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import ReactTooltip from "react-tooltip";

function PercentChanged(props) {
  props = {
    toolTip: "",
    currencySymbol: "",
    fontSize: "16px",
    style: {},
    hideChange: false,
    hidePercentIfLessOne: false,
    positiveColor: "#21e981",
    negativeColor: "#c7343e",
    digits: 0,
    ...props
  };

  const changeValuePercent = props.changeValue * 100;
  const percent = changeValuePercent.toFixed(props.digits);
  let percentValue = `${percent > 0 ? "+" : ""}${percent}%`;

  if (props.hidePercentIfLessOne) {
    if (Math.abs(changeValuePercent) < 1) {
      percentValue = "—";
    }
  }

  return (
    <div
      style={{
        ...styles.container,
        fontSize: props.fontSize
      }}
      data-testid="percentChange"
    >
      {Number.isFinite(props.changeValue) && (
        <span
          data-tip={props.toolTip}
          className="percent-changed"
          style={[
            styles.baseStyle,
            props.showBorder && styles.withBorder,
            props.changeValue > 0 ? { color: props.positiveColor } : { color: props.negativeColor },
            (percent === 0 || !percentValue.includes("%")) && styles.noColor,
            props.currencySymbol === "د.ك" ? styles.floatLeft : styles.floatRight
          ]}
        >
          {percent >= -999 && percent <= 999 ? (
            <>
              {percentValue}
              <span className="percent-changed-note" style={styles.note}>
                {props.note}
              </span>
            </>
          ) : (
            <>{percent > 999 ? ">" : "<-"}999%</>
          )}
        </span>
      )}
      {props.toolTip ? <ReactTooltip /> : ""}
    </div>
  );
}

PercentChanged.propTypes = {
  changeValue: PropTypes.any,
  showBorder: PropTypes.bool,
  note: PropTypes.string,
  toolTip: PropTypes.string,
  currencySymbol: PropTypes.string,
  fontSize: PropTypes.string,
  hideChange: PropTypes.bool,
  hidePercentIfLessOne: PropTypes.bool,
  digits: PropTypes.number,
  positiveColor: PropTypes.string,
  negativeColor: PropTypes.string
};
const styles = {
  container: {
    display: "inline-block"
  },
  baseStyle: {
    padding: 5,
    fontWeight: "800",
    display: "flex"
  },
  icon: {
    width: "8px",
    display: "inline-block"
  },
  positive: {
    color: "#21e981"
  },
  negative: {
    color: "#c7343e"
  },
  floatLeft: {
    float: "left",
    padding: "36px 5px 0 0"
  },
  floatRight: {},
  withBorder: {
    border: "1px solid grey",
    borderRadius: 5,
    padding: "2px 10px 2px 10px",
    position: "relative",
    left: "10px",
    display: "inline",
    top: "-5px"
  },
  note: {
    textTransform: "uppercase",
    fontSize: "10px",
    color: "#8b92a1"
  },
  noColor: {
    color: "rgb(135, 145, 160)"
  }
};

export default Radium(PercentChanged);
